import BlogList from "../components/BlogList";
import useFetch from "../hooks/uesFetch";
const Home = () => {
  const {
    data: blogs,
    error,
  } = useFetch("http://localhost:8000/blogs");
  return (
    <div className="home">
      {error && <div>{error}</div>}
      {blogs && <BlogList blogs={blogs} title="All Blogs" />}
    </div>
  );
};
export default Home;
